export enum SubscriptionType {
  Subscription = 'subscription',
  PayAsYouGym = 'pay-as-you-gym',
}
